export default function Error404() {
    return (
        <main>
          <h1>404 Not Found</h1>
        </main>
    );
  }